import { render } from "./ErrorExclamationSvg.vue?vue&type=template&id=3ead8349"
import script from "./ErrorExclamationSvg.vue?vue&type=script&lang=js"
export * from "./ErrorExclamationSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__